module.exports = __webpack_public_path__ + "files/985ba4b03b8bf985290de21abcd82bd1.png";